import { JtechStore } from 'src/plugins/mobx'

export class ControllerStoreBase {
  static construct (instance, loadStorage) {
    return JtechStore.getSingleton(instance.getName(), instance, loadStorage)
  }

  getName () {
    return ''
  }
}
